var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-grey-600 flex flex-row h-full text-1 text-white"},[_c('SpecialMenuHeader',{attrs:{"color":_vm.header.color,"data-test":"header"}},[_vm._v("\n    "+_vm._s(_vm.header.label)+"\n  ")]),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }